import { ChangeDetectionStrategy, Component, OnDestroy, inject } from '@angular/core';
import { map } from 'rxjs/operators';
import { Subscription } from 'rxjs';
import { TenantService } from '../../services/tenant.service';
import { IonicModule } from '@ionic/angular';
import { AsyncPipe } from '@angular/common';

@Component({
    selector: 'app-maintenance-banner',
    templateUrl: './maintenance-banner.component.html',
    styleUrls: ['./maintenance-banner.component.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush,
    imports: [IonicModule, AsyncPipe],
})
export class MaintenanceBannerComponent implements OnDestroy {
  readonly isVisible$ = inject(TenantService).activeTenant$.pipe(
    map((t) => t?.maintenanceBannerEnabled === true),
  );

  private readonly sub: Subscription = this.isVisible$.subscribe((visible) => {
    document.body.classList.toggle('maintenance-banner-active', visible);
  });

  ngOnDestroy(): void {
    this.sub.unsubscribe();
    document.body.classList.remove('maintenance-banner-active');
  }
}
